<template>
  <modal
      id="app-redeem-product-modal"
      size="large"
      v-model="showModal"
      title="Redeem Product"
      @submit="submit"
      :loading="loading"
      :btn-label="selectedUrl ? $t('save') : $t('add')"
      :preloader="preloader">

            <form
                v-if="(isMailSettingExist || selectedUrl) && !preloader"
                ref="form"
                method="post"
                enctype="multipart/form-data"
                :data-url='PRODUCT_REDEEM'
                @submit.prevent="submitData"
            >
              <div class="row">
                <div class="col-md-12">
                  <app-form-group
                      type="text"
                      :class="'text-uppercase'"
                      :label="$t('search')"
                      v-model="searchTerm"
                      placeholder="Enter voucher code"
                      :error="!!error_message"
                      :error-message="$errorMessage(errors, 'search')"
                  />
                  <span v-if="error_message" class="text-danger mt-0 mb-2">{{error_message}}</span>
                </div>
              </div>
              <div v-if="formData">
                <div class="row">
                  <div class="col-md-12">
                    <app-form-group
                        type="text"
                        :label="$t('product')"
                        disabled
                        v-model="formData.title ?? ''"
                        :error-message="$errorMessage(errors, 'product')"
                    />
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-12">
                    <img :src="formData.product.image" :alt="formData.title" style="max-width: 200px; border-radius: 10px;">
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-6">
                    <app-form-group
                        type="text"
                        :label="$t('quantity')"
                        disabled
                        v-model="formData.quantity ?? ''"
                        :error-message="$errorMessage(errors, 'quantity')"
                    />
                  </div>
                  <div class="col-md-6">
                    <app-form-group
                        type="text"
                        :label="$t('price')"
                        disabled
                        v-model="formData.price ?? ''"
                        :error-message="$errorMessage(errors, 'price')"
                    />
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-6">
                    <app-form-group
                        type="text"
                        :label="$t('user')"
                        disabled
                        v-model="formData.user.first_name + ' ' + formData.user.last_name ?? ''"
                        :error-message="$errorMessage(errors, 'user')"
                    />
                  </div>
                  <div class="col-md-6">
                    <app-form-group
                        type="text"
                        :label="$t('employee_id')"
                        disabled
                        v-model="formData.user.id ?? ''"
                        :error-message="$errorMessage(errors, 'employee_id')"
                    />
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-6">
                    <app-form-group
                        type="text"
                        :label="$t('bought_at')"
                        disabled
                        v-model="formattedDate"
                        :error-message="$errorMessage(errors, 'bought_at')"
                    />
                  </div>
<!--                  <div class="col-md-6">-->
<!--                    <app-form-group-->
<!--                        type="text"-->
<!--                        :label="$t('employee_id')"-->
<!--                        disabled-->
<!--                        v-model="formData.user.id ?? ''"-->
<!--                        :error-message="$errorMessage(errors, 'employee_id')"-->
<!--                    />-->
<!--                  </div>-->
                </div>
              </div>

            </form>
<!--              <template v-if="!selectedUrl" slot="modal-footer" class="modal-footer">-->
<!--                <button type="button"-->
<!--                        class="btn btn-secondary"-->
<!--                        data-dismiss="modal">-->
<!--                  {{ $t('close') }}-->
<!--                </button>-->
<!--                <button type="submit"-->
<!--                        class="btn btn-primary ml-3">-->
<!--                  Redeem-->
<!--                </button>-->
<!--  &lt;!&ndash;                      @click="this.redeemProduct"&ndash;&gt;-->
<!--              </template>-->

  </modal>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {
  BOUGHT_PRODUCT,
  SHOP_HOME,
  PRODUCT_REDEEM,
} from "../../../Config/ApiUrl";
import {
  TENANT_MAIL_CHECK_URL,
} from "../../../../common/Config/apiUrl";
import {axiosGet, axiosPost, urlGenerator} from "../../../../common/Helper/AxiosHelper";
import LogMixin from "../../Mixins/LogMixin";
import {textEditorHints} from "../../../../common/Helper/Support/TextEditorHelper";
import TemplateMixins from "../../../../common/Components/Settings/Common/http/NotificationTemplate/TemplateMixins";
import {InputMixin} from "../../../../core/components/input/mixin/InputMixin";
import _ from "lodash";
import {kebabCase} from "../../../../common/Helper/Support/TextHelper";
import moment from 'moment';
// import { mapState, mapActions } from 'vuex';

export default {
  name: "RedeemProductModal",
  mixins: [FormHelperMixins, ModalMixin, LogMixin, TemplateMixins, InputMixin],
  props: {
    from: {
      type: String,
      default: 'redeem-product'
    },
    data: {
      type: Object,
      default: () => ({})
    },
    loaderColor: {
      type: String,
      default: 'white-color'
    },
  },
  data() {
    return {
      error_message: "",
      textEditorHints,
      maps: null,
      imageUploaderBoot: false,
      image: {
        product_image: null
      },
      // 'multi_day', 'single_day', 'last_half', 'hours', 'first_half'
      leaveTypes: [
        // { id: 'short_leave', label: 'Short Leave' },
        // { id: 'paid_leave', label: 'Paid Leave' },
        // { id: 'casual_leave', label: 'Casual Leave' }
      ],
      isMailSettingExist: true,
      preloader: false,
      loading: false,
      dataLoading: false,
      searchTerm: '',
      formData: {
        title: "",
        price: 0.0,
        description: "",
        image: "",
        status: "",
        stock: 0,
        quantity: 0,
        leave_type: "",
        duration: "",
        duration_type: "",
        voucher_no: "",
      },
      SHOP_HOME,
      PRODUCT_REDEEM,
    }
  },
  methods: {
    // ...mapActions(['closeModal']),
    propsFor() {
      let props = this.$attrs;
      const cTor = this.$options.components['app-input']
      if (cTor) {
        let keys = Object.keys(cTor.options.props)
        return _.pick(props, keys.map(key => {
          return kebabCase(key)
        }))
      }
    },
    submit() {
      this.fieldStatus.isSubmit = true;
      this.loading = true;
      this.message = '';
      this.errors = {};

      console.log(this.formData);
      this.submitData(this.formData);
    },
    afterSuccess({data}) {
      this.formData = {};
      $('#app-redeem-product-modal').modal('hide');
      this.$emit('input', false);
      this.toastAndReload(data.message, this.from === 'redeem-product' ? 'redeem-product-table' : 'user-table');
      if (this.from === 'redeem-product') {
        this.$hub.$emit(`redeem-product-table`)
      }
    },
    afterSuccessFromGetEditData({data}) {
      console.log("afterSuccessFromGetEditData");
      this.preloader = false;
      //Before customization this was "  this.formData = data;"
      this.formData = {...this.formData, ...data};
    },
    generateModalTitle(subject) {
      return this.$fieldTitle(this.selectedUrl ? 'edit' : 'add', subject, true);
    },
    async fetchProduct(searchTerm) {
      console.log('redeem product');
      this.dataLoading = true;
      this.loading = true;
      // Make an AJAX request to fetch products based on the searchTerm
      await axios.get('/shop/search', { params: { search: searchTerm } })
          .then(response => {
            if (response.data.message) {
              this.error_message = response.data.message;
              this.dataLoading = false;
              this.loading = false;
              this.closeModal();
            }
            else if (response.data) {
              // Handle the response, e.g., set a data property to the fetched products
              this.formData = response.data;
              this.error_message = "";
              this.dataLoading = false;
              this.loading = false;
              this.closeModal();
            }
          })
          .catch(error => {
            console.error('Error fetching products:', error);
          });
    },
    // toggleModal() {
    //   this.isModalActive = true;
    //   this.showModal = true;
    // },
  },
  created() {
    // EventBus.$on('open-modal', this.toggleModal);
    console.log(this.data);
    this.formData = this.data;
    this.searchTerm  = this.formData.voucher_no;
    // this.showModal = false;
    // this.fetchLeaveTypes();
  },
  computed: {
    // ...mapState(['isModalActive']),
    formattedDate() {
      return moment(this.formData.created_at).format('YYYY-MM-DD') ?? '';
    },
    fileLabel() {
      if (this.value && this.fieldValue && this.fieldValue === this.value)
        return this.value?.name ? this.value.name : this.data.label;
      else return this.data.label;
    }
  },
  mounted() {
  },
  watch: {
    searchTerm(newVal) {
      this.fetchProduct(newVal);
    },
  },
}
</script>